export default {
    current_choice: 'Current choice',
    book_now: 'Book now',
    minimum_age: "Over {age}'s Only",
    excess_liability: 'Excess liability',
    security_deposit: 'Security deposit',
    fuel_policy: 'Fuel policy',
    like_for_like: 'Like for Like',
    full_to_full: 'Full to Full',
    miles_per_rental: '{mileage} free miles per rental',
    km_per_rental: '{mileage} free km per rental',
    unlimited_mileage: 'Unlimited mileage',
    unlimited_mileage_km: 'Unlimited km',
    non_amendable: 'Non amendable',
    non_refundable: 'Non refundable',
    free_cancellation_until: 'Free cancellation up until',
    basic_free_cancellation: 'Free cancellation up to 48 hours before start time',
    cancellation_in_line_with: 'Cancellation in line with',
    tcs: 'T&amp;Cs',
    free_extras_on_collection: 'Two free extras on collection',
    glass_and_tyres_covered: 'Glass and tyres covered',
    number_of_passengers: 'Number of passengers',
    number_of_bags: 'Number of bags',
    fuel_type: 'Fuel type',
    co2: 'CO2',
    aircon: 'Air con',
    transmission: 'Transmission',
    book_type: 'Book {type}',
    debit_card_deposit: 'Debit Card Accepted for Deposits',
    fast_track_included: 'Fast Track Included',
    view_all: 'View all',
};
